import React from "react";
import "./AboutUs.css";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import "../CSS/Background.css";

export default function AboutUs() {
  // Structured data for SEO
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Your Christmas Tree Company",
    "description": "Family-owned Christmas tree lot in West Los Angeles selling premium Noble Fir, Douglas Fir, Fraser Fir, Nordman Fir, Grand Fir, and Silvertip trees for 44 years",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "West Los Angeles",
      "addressRegion": "CA",
      "addressCountry": "US"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "09:00",
      "closes": "21:00"
    },
    "priceRange": "$$",
    "paymentAccepted": "Cash, Credit Card",
    "areaServed": {
      "@type": "City",
      "name": "Los Angeles"
    },
    "knowsAbout": [
      "Christmas Trees",
      "Noble Fir",
      "Douglas Fir",
      "Fraser Fir",
      "Nordman Fir",
      "Grand Fir",
      "Silvertip Fir",
      "Christmas Wreaths",
      "Tree Delivery",
      "Tree Flocking"
    ]
  };

  return (
    <>
      {/* Structured Data JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>

      <Box
        component="section"
        aria-label="About Our Christmas Tree Business"
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: "8px",
        }}
      >
        {/* Hidden H1 for SEO */}
        <h1 className="visually-hidden">
          Premium Christmas Trees in West Los Angeles - 44 Years of Quality Service
        </h1>

        <Box 
          component="article" 
          className="about-us-text-box"
          itemScope
          itemType="https://schema.org/AboutPage"
        >
          <Typography 
            component="p" 
            className="about-us-text" 
            color="text.main"
            itemProp="description"
          >
            We have been selling Christmas trees in West Los Angeles for 44 years.
            We are one of the oldest individually owned Christmas tree lot in the
            area, with an ever increasing loyal and discriminating clientele,
            which surprises us by following us year after year of peregrinations
            through the city. We have earned our reputation with a lot of
            research, hard work, and fair prices.
          </Typography>

          <Typography 
            component="p" 
            className="about-us-text" 
            color="text.main"
          >
            For almost ten years, we walked miles and miles of Christmas tree
            farms hand picking the best trees. We have learned a lot along the
            years and always buy trees from smaller, more quality minded growers.
            Smaller and more frequent shipments guarantees that our trees are
            always fresh. We also take very good care of our trees, watering them
            every day and keeping them in water as soon as they are opened.
          </Typography>

          <Typography 
            component="p" 
            className="about-us-text" 
            color="text.main"
          >
            We are known for having a really good variety and having large trees
            on our lots. We have trees as small as 2 ft tall up to 13 ft tall. We
            carry <strong>Douglas Fir</strong>, <strong>Noble Fir</strong>, <strong>Nordman Fir</strong>, <strong>Grand Fir</strong>, and <strong>Silver Tips</strong>. We also have really beautiful wreaths in six different
            sizes.
          </Typography>

          {/* Additional semantic markup for key features */}
          <div itemScope itemType="https://schema.org/ItemList" style={{ display: "none" }}>
            <meta itemProp="name" content="Christmas Tree Varieties" />
            <div itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <meta itemProp="position" content="1" />
              <meta itemProp="name" content="Douglas Fir Christmas Trees" />
            </div>
            <div itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <meta itemProp="position" content="2" />
              <meta itemProp="name" content="Noble Fir Christmas Trees" />
            </div>
            <div itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <meta itemProp="position" content="3" />
              <meta itemProp="name" content="Nordman Fir Christmas Trees" />
            </div>
            <div itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <meta itemProp="position" content="4" />
              <meta itemProp="name" content="Grand Fir Christmas Trees" />
            </div>
            <div itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <meta itemProp="position" content="5" />
              <meta itemProp="name" content="Silvertip Fir Christmas Trees" />
            </div>
          </div>
        </Box>
      </Box>
    </>
  );
}